<template>
  <div class="MyOutLine">
    <AppHeader v-if="isAdd">
      <el-page-header
          @back="goBack"
          title="返回"
          :content="isAddContent"
      ></el-page-header>
      <!--<el-button size="small" type="primary" @click="handleEditOutLine"
        >修改流程
      </el-button>-->
    </AppHeader>
    <AppHeader v-else>
      <el-page-header
          @back="goBack"
          title="返回"
          :content="isEditContent"
      ></el-page-header>
      <!--<el-button size="small" type="primary" @click="handleEditOutLine"
        >修改流程
      </el-button>-->
    </AppHeader>
    <AppBox class="appBox">
      <!-- 标题-->
      <div class="boxTitle">
        <div>制作课程：{{ lessonName }}</div>
      </div>
      <!--AppBox-->
      <div class="contentBox">
        <!--左边表格-->
        <div class="leftContent">
          <!--循环的每一个大纲模块-->
          <div
              class="itemOutLine"
              v-for="(item, index) in outLineArr"
              :key="item.id"
          >
            <div
                :class="isActive === index ? 'activeClass' : 'outLineBtn'"
                @click="handleActive(index, item)"
            >
              {{ item.module }}
            </div>
            <div class="table">
              <XTable
                  ref="table"
                  v-if="stateArr && stateArr[index]"
                  :state="stateArr[index]"
                  :columns="columns"
                  :loading="lessonContentListLoading"
                  :tableSize="tableSize"
                  :maxHeight="maxHeight"
                  :layout="layout"
                  :editRowId="editRowId"
                  @row-click="rowClick"
              ></XTable>
            </div>
          </div>
        </div>
        <!--                右边手机模型-->
        <div class="rightContent">
          <div>
            <IPhoneModelContainer ref="iPhoneModelContainer"></IPhoneModelContainer>
          </div>
          <div style="margin: 10px 0 0 20px; text-align: center">
            <i class="el-icon-refresh" @click="handleRefreshIframe"></i>
            <div class="refreshText">刷新预览</div>
          </div>
        </div>
      </div>
      <template>
        <div class="footer">
          <el-button
              v-if="anyEmpty"
              style="width: 150px"
              type="primary"
              @click="handleStartMakeLesson"
          >制作课程
          </el-button>
          <el-button
              v-if="isCommit"
              style="width: 150px;"
              type="primary"
              @click="handleReviewKnowledgePoint"
          >知识点回顾
          </el-button>
          <el-button v-if="isCommit" style="width: 150px" type="primary" @click="handleCommit"
          >提交审核
          </el-button>
        </div>
      </template>
    </AppBox>
    <AddLessonContentModalV1
        :addType="addType"
        @initTable="initTable"
        @activeItem="handleFromSon"
    ></AddLessonContentModalV1>
    <AddLessonContentModalV2
        :addType="addType"
        @initTable="initTable"
        @activeItem="handleFromSon"
    ></AddLessonContentModalV2>
    <knowledge-point-review-modal
        :lessonId="lessonId"
        :version="version"
    ></knowledge-point-review-modal>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import {MODULE_TYPE} from "@/utils/constants";
import AddLessonContentModalV1 from "@/pages/MyOutLine/AddLessonContentModalV1.vue";
import AddLessonContentModalV2 from "@/pages/MyOutLine/AddLessonContentModalV2.vue";
import KnowledgePointReviewModal from "@/pages/MyOutLine/KnowledgePointReviewModal.vue";
import IPhoneModelContainer from "@/components/ui/IPhoneModelContainer/index.vue";

export default {
  name: "MyOutLine",
  components: {
    IPhoneModelContainer,
    KnowledgePointReviewModal,
    AddLessonContentModalV1,
    AddLessonContentModalV2,
    XTable,
    AppBox,
    AppHeader,
  },
  data() {
    const self = this;
    const columns = [
      {
        prop: "sequence",
        label: "序号",
      },
      {
        prop: "id",
        label: "编号",
      },
      {
        label: "角色",
        minWidth: "50",
        render(h, scope) {
          return (
              <div>
                {scope.row &&
                    scope.row.content.trigger &&
                    scope.row.content.trigger === "NEXT_SECTION_GUIDE" && (
                        <span>-</span>
                    )}
                {scope.row &&
                    scope.row.content.trigger !== "NEXT_SECTION_GUIDE" && (
                        <span>{[scope.row.content.role]}</span>
                    )}
              </div>
          );
        },
      },
      {
        label: "形式",
        minWidth: "90",
        render(h, scope) {
          if (scope.row.type == "subject") {
            return (
                <div>
                  <span>练习题</span>
                </div>
            );
          } else {
            return (
                <div>
                  <span>{MODULE_TYPE[scope.row.type]}</span>
                </div>
            );
          }
        },
      },
    ];
    return {
      isAdd: true,
      isAddContent: "课程管理 | 新增课程",
      isEditContent: "课程管理 | 编辑课程",
      isCommit: false,
      anyEmpty: false,
      addType: "add",
      lessonId: null,
      version: null,
      outLineId: null,
      modelItem: null,
      hasPagination: false,
      tableSize: "small",
      maxHeight: 30000,
      editRowId: null,
      lessonName: null,
      layout: "",
      stateArr: [],
      isActive: 0,
      outLineArr: [],
      columns: [
        ...columns,
        {
          label: "调整|移动",
          minWidth: "150",
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleUp(scope);
                      }}
                      disabled={scope.$index === 0}
                      size="mini"
                      type="primary"
                      plain
                  >
                    上移
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDown(scope);
                      }}
                      disabled={scope.store.states.data.length === scope.$index + 1}
                      size="mini"
                      type="primary"
                      plain
                  >
                    下移
                  </el-button>
                </div>
            );
          },
        },
        {
          label: "操作",
          minWidth: "240",
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleEdit(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    编辑
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDelete(scope.row);
                      }}
                      size="mini"
                      type="danger"
                      plain
                  >
                    删除
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleAddDown(scope);
                      }}
                      disabled={scope.row.model === "下节引入"}
                      size="mini"
                      type="primary"
                  >
                    下方添加
                  </el-button>
                </div>
            );
          },
        },
      ],
    };
  },
  computed: {
    ...mapState("courseCenter", [
      "lessonContentListLoading",
      "lessonContentList",
      "editOutLineDetail",
      "addLessonContentModalV1Visible",
      "addLessonContentModalV2Visible",
      "knowledgePointReviewModalVisible",
    ]),
  },
  async mounted() {
    if (this.$route.params.type === "add") {
      this.isAdd = true;
    }
    if (this.$route.params.type === "edit") {
      this.isAdd = false;
    }
    await this.getLessonEditOutline({
      id: Number(this.$Base64.decode(this.$route.params.lessonId)),
    });
    await this.initTable();
    let loglevel = localStorage.getItem("loglevel:webpack-dev-server");
    if (loglevel) {
      localStorage.removeItem("loglevel:webpack-dev-server");
    }
    loglevel = null;
  },
  methods: {
    ...mapActions("courseCenter", [
      "getLessonContent",
      "getLessonEditOutline",
      "deleteLessonContent",
      "moveLessonContent",
      "submitLessonVersion",
      "getLessonPointReviewContentList",
    ]),
    ...mapMutations("courseCenter", ["setData"]),
    rowClick(row) {
      this.$refs.iPhoneModelContainer.setContentId(row.id);
    },
    // 刷新iframe
    handleRefreshIframe() {
      this.$refs.iPhoneModelContainer.getDataFromFa(this.editOutLineDetail.lessonId, this.editOutLineDetail.version)
    },
    // 初始化表格
    async initTable() {
      // 根据大纲id获取大纲内容
      this.lessonId = this.editOutLineDetail.lessonId;
      this.version = this.editOutLineDetail.version;
      this.outLineId = this.editOutLineDetail.id;
      this.outLineArr = this.editOutLineDetail.outline;
      this.modelItem = this.editOutLineDetail.outline[0];
      this.lessonName = this.editOutLineDetail.lessonName;

      const res = await this.getLessonContent({
        lessonId: this.lessonId,
        version: this.editOutLineDetail.version,
      });
      this.stateArr = res.data;
      const arr1 = this.stateArr.filter(
          (item) => item.lessonContentList.length < 1
      );
      this.anyEmpty = arr1.length > 0;
      let arr2 = this.stateArr.filter(
          (item) => item.lessonContentList.length > 0
      );
      this.isCommit = arr2.length > 0;
      console.log(this.stateArr)
      console.log(this.isCommit)
      const moduleIndex = Number(localStorage.getItem("moduleIndex"));
      if (moduleIndex) {
        if (moduleIndex === 0) {
          this.$nextTick(() => {
            this.$refs.table[
                moduleIndex
                ].$refs.xTable.$refs.appTable.doLayout();
          });
        } else {
          this.$nextTick(() => {
            this.$refs.table[
            moduleIndex - 1
                ].$refs.xTable.$refs.appTable.doLayout();
          });
        }
      }
      this.handleRefreshIframe();
    },
    //点击高亮,可编辑当前大纲下的课程内容
    handleActive(index, item) {
      if (this.isActive === index) {
        this.isActive = 0;
        this.modelItem = this.editOutLineDetail.outline[0];
      } else {
        this.isActive = index;
        this.modelItem = item;
      }
    },
    //由弹框点击下一个模块的高亮
    handleFromSon() {
      this.isActive = JSON.parse(localStorage.getItem("moduleIndex"));
      this.modelItem = JSON.parse(localStorage.getItem("modelItem"));
    },
    // 修改大纲
    async handleEditOutLine() {
      await this.$router.push(
          {
            name: "AddOutLine",
            params: {
              classSubjectId: this.$route.params.classSubjectId,
              classSubjectName: this.$route.params.classSubjectName,
              lessonId: this.$Base64.encode(this.lessonId),
              type: this.$route.params.type,
            },
          },
          () => {
          }
      );
    },
    // 开始创建
    handleStartMakeLesson() {
      this.addType = "add";
      localStorage.setItem(
          "modelItem",
          JSON.stringify(this.editOutLineDetail.outline[this.isActive])
      );
      localStorage.setItem("moduleIndex", JSON.stringify(this.isActive));
      this.setData({key: "addLessonContentModalV2Visible", value: true});
    },
    // 返回课程列表
    async goClassListPage() {
      // const responseListDetail = JSON.parse(
      //   localStorage.getItem("isActiveDetail")
      // );
      await this.$router.push(
          {
            name: "CourseList",
            params: {
              classSubjectId: this.$route.params.classSubjectId,
              classSubjectName: this.$route.params.classSubjectName,
            },
          },
          () => {
          }
      );
    },
    // 知识点回顾
    async handleReviewKnowledgePoint() {
      await this.getLessonPointReviewContentList({
        lessonId: this.lessonId,
        version: this.editOutLineDetail.version,
      });
      this.setData({key: "knowledgePointReviewModalVisible", value: true});
    },
    // 提交审核
    async handleCommit() {
      this.$confirm("请确认课程已制作完成，提交审核!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await this.submitLessonVersion({
              lessonId: this.lessonId,
              version: this.editOutLineDetail.version,
            });
            this.$message.success("提交成功");
            await this.goClassListPage();
          })
          .catch(() => {
          });
    },
    // 上移
    async handleUp(scope) {
      this.activeOutLine(scope.row.modelId);
      await this.moveLessonContent({
        lessonId: this.lessonId,
        version: this.editOutLineDetail.version,
        modelId: scope.row.modelId,
        offset: scope.$index + 1,
        previewDirect: true,
        step: 1,
      });
      await this.initTable();
    },
    // 下移
    async handleDown(scope) {
      this.activeOutLine(scope.row.modelId);
      await this.moveLessonContent({
        lessonId: this.lessonId,
        version: this.editOutLineDetail.version,
        modelId: scope.row.modelId,
        offset: scope.$index + 1,
        previewDirect: false,
        step: 1,
      });
      await this.initTable();
    },
    // 编辑
    async handleEdit(row) {
      this.editRowId = row.id;
      this.activeOutLine(row.modelId);
      this.addType = "edit";
      await localStorage.setItem("lessonContentRow", JSON.stringify(row));
      if (row.content.version == 2) {
        await this.setData({
          key: "addLessonContentModalV2Visible",
          value: true,
        });
      } else {
        await this.setData({
          key: "addLessonContentModalV1Visible",
          value: true,
        });
      }
    },
    // 删除
    async handleDelete(row) {
      this.activeOutLine(row.modelId);
      this.$confirm("确定要删除此条内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await this.deleteLessonContent({
              id: row.id,
            });
            await this.initTable();
            this.$message({
              type: "success",
              message: "删除成功",
            });
          })
          .catch(() => {
          });
    },
    // 下方添加
    handleAddDown(scope) {
      this.editRowId = scope.row.id;
      this.activeOutLine(scope.row.modelId);
      const arr = this.outLineArr.filter(
          (item) => item.id === scope.row.modelId
      );
      localStorage.setItem("modelItem", JSON.stringify(arr[0]));
      localStorage.setItem("operateOffset", JSON.stringify(scope.$index + 1));
      this.addType = "downAdd";
      this.setData({key: "addLessonContentModalV2Visible", value: true});
      // this.setData({ key: "addLessonContentModalV1Visible", value: true });
    },
    //根据moduleId查询大纲index高亮
    activeOutLine(id) {
      const activeIndex = this.outLineArr.findIndex((item) => item.id === id);
      this.isActive = activeIndex;
      this.modelItem = this.editOutLineDetail.outline[activeIndex];
      localStorage.setItem("moduleIndex", JSON.stringify(activeIndex));
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  beforeDestroy() {
    this.setData({key: "addLessonContentModalV2Visible", value: false});
    this.setData({key: "knowledgePointReviewModalVisible", value: false});
  },
};
</script>
<style>
.MyOutLine {
  .table {
    .el-table__row {
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss" scoped>
.MyOutLine {
  //overflow: hidden;
  .appBox {
    width: 100%;
    height: calc(100vh - 165px);
    min-height: 390px;

    .boxTitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #666666;
    }

    .contentBox {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      .rightContent {
        height: calc(100vh - 322px);
        width: 30%;
        display: flex;
        justify-content: center;
        //max-width: 300px;
        //min-width: 300px;
        //background: #f2f2f2;
        //padding: 20px;
        margin-left: 10px;

        .el-icon-refresh {
          color: #10689c;
          font-weight: bold;
          font-size: 25px;
          cursor: pointer;
        }

        .refreshText {
          color: #10689c;
          margin-top: 10px;
          font-size: 13px;
        }
      }

      .leftContent {
        width: 70%;
        box-shadow: -5px 5px 5px #f1f1f1;
        padding: 20px;
        height: calc(100vh - 322px);
        overflow-y: auto;

        .itemOutLine {
          display: flex;
          align-items: flex-start;

          .table {
            width: 100%;
          }


          .outLineBtn {
            text-align: center;
            background: #e7f0f5;
            min-width: 100px;
            border-radius: 3px;
            color: #10689c;
            border: 1px solid #10689c;
            padding: 8px;
            cursor: pointer;
            margin-right: 20px;
            margin-bottom: 20px;
          }

          .activeClass {
            text-align: center;
            background: #10689c;
            min-width: 100px;
            border-radius: 3px;
            border: 1px solid #10689c;
            box-shadow: 0 2px 15px #10689c;
            color: #ffffff;
            padding: 8px;
            cursor: pointer;
            margin-right: 20px;
            margin-bottom: 20px;
          }
        }
      }
    }

    .footer {
      margin-top: 20px;
      width: 60%;
      text-align: center;
    }
  }
}
</style>
